import React, { useState, memo } from "react";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import "./ResetPassword.css";
import { Form, Formik } from "formik";
// import { resetPasswordSchema } from "../../utils/formValidations";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { requestResetPassword } from "../../store/models/auth/auth.thunk";
import { useAppDispatch, useAppSelector } from "../../store/hooks/store.hooks";
import { useMediaQuery } from "react-responsive";
import {
  Box,
  Button,
  CircularProgress,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  InputAdornment,
  Typography,
} from "@mui/material";
import { setPasswordModal } from "../../store/models/auth/auth.slice";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { ReCaptchaComponent } from "../ReCaptcha";

interface IResetPassword {}

const ResetPassword: React.FC<IResetPassword> = memo(({}) => {
  const open = useAppSelector((state) => {
    return state.authorization.passwordModal;
  });
  const [infoMessage, setInfoMessage] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();
  const isMobile = useMediaQuery({ maxWidth: 600 });
  const { t, i18n } = useTranslation();

  const resetPasswordSchema = Yup.object().shape({
    resetEmail: Yup.string()
      .matches(/^(?=.*[A-Za-z])/g, i18n.t("validationschema.onlyEn"))
      .email(i18n.t("validationschema.email"))
      .required(i18n.t("validationschema.emailRequired"))
      .matches(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        i18n.t("validationschema.email")
      ),
    token: Yup.string().required(i18n.t("validationschema.check")),
  });

  const handleClose = () => {
    dispatch(setPasswordModal(false));
  };

  const handleSubmit = async (
    data: any,
    { setSubmitting, setFieldError, setStatus }: any
  ) => {
    const { resetEmail } = data;
    setLoading(true);
    const response = await dispatch(
      requestResetPassword({
        email: resetEmail,
      })
    );
    // debugger;
    //@ts-ignore
    if (response?.payload?.message === "User not found") {
      setFieldError("resetEmail", "Пользователя не существует");
      setSubmitting(false);
    } else {
      setInfoMessage(true);
      handleClose();
    }

    setLoading(false);
  };

  return (
    <>
      <Dialog
        sx={{
          height: {
            xs: "calc(var(--real-vh) - 56px - 80px)",
            sm: "calc(var(--real-vh) - 84px)",
          },
          top: { xs: "56px", sm: "84px" },

          overflowY: "auto",
          ".MuiDialog-container": {
            height: "auto",
            alignItems: { xs: "flex-start", sm: "center" },
            padding: {
              xs: "56px 0 80px",
              sm: "84px 0 80px",
            },
            marginTop: "0px",
          },
        }}
        PaperProps={{
          sx: {
            margin: "0",
            width: "100%",
            maxWidth: "400px",
            height: "auto",
            maxHeight: "100%",
            borderRadius: "var(--primary-border-radius)",
            overflowY: "unset",
          },
        }}
        open={open}
        onClose={handleClose}
      >
        <DialogTitle
          className="reset_password_dialog-title"
          align="center"
          sx={{
            borderRadius:
              "var(--primary-border-radius) var(--primary-border-radius) 0 0",
            backgroundColor: "var(--secondary-background-color)",
            fontSize: "12px",
            lineHeight: "12px",
            textTransform: "uppercase",
            padding: "21px 0",
            position: "relative",
          }}
        >
          {t("reset_password.title")}
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: "14px",
              top: "50%",
              width: "20px",
              height: "20px",
              transform: "translate(0, -50%)",
              backgroundColor: "var(--primary-background-color)",
              padding: "0",
              borderRadius: "4px !important",
            }}
          >
            <CloseIcon sx={{ fontSize: "16px" }} />
          </IconButton>
        </DialogTitle>
        <DialogContent
          className="reset_password_dialog-content"
          sx={{ overflowY: "unset" }}
        >
          <Typography
            style={{
              fontSize: "12px",
              padding: "12px 0",
            }}
            className="primary-text-color"
            align="center"
          >
            {t("reset_password.text")}
          </Typography>

          <Formik
            onSubmit={handleSubmit}
            initialValues={{
              resetEmail: "",
              token: "",
            }}
            validationSchema={resetPasswordSchema}
          >
            {({
              errors,
              touched,
              handleChange,
              handleBlur,
              values,
              setValues,
            }) => (
              <Form>
                <Box style={{ position: "relative" }}>
                  <TextField
                    error={Boolean(errors.resetEmail && touched.resetEmail)}
                    type="email"
                    size="small"
                    margin="normal"
                    fullWidth
                    id="resetEmail"
                    // label="Твой email"
                    name="resetEmail"
                    placeholder={t("authorization.fields.loginEmail")}
                    autoComplete="off"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.resetEmail}
                    InputProps={
                      errors.resetEmail && touched.resetEmail
                        ? {
                            endAdornment: (
                              <InputAdornment position="end">
                                <ErrorOutlineOutlinedIcon
                                  style={{
                                    color: "rgba(223, 0, 67, 1)",
                                    fontWeight: 700,
                                  }}
                                />
                              </InputAdornment>
                            ),
                          }
                        : undefined
                    }
                  />
                  {errors.resetEmail && touched.resetEmail ? (
                    <Typography
                      className="Typography-error"
                      component="p"
                      variant="body2"
                    >
                      {errors.resetEmail}
                    </Typography>
                  ) : null}
                </Box>
                <ReCaptchaComponent
                  sx={{ marginTop: "10px" }}
                  callback={(token: any) => {
                    setValues({ ...values, token });
                  }}
                />
                <Button
                  className={"Button Button-secondary"}
                  type="submit"
                  fullWidth
                  variant="outlined"
                  sx={{ mt: 3, mb: 2 }}
                  disabled={loading}
                >
                  {loading ? (
                    <CircularProgress
                      style={{
                        height: "25px",
                        width: "25px",
                        color: "rgb(223, 0, 67)",
                      }}
                    />
                  ) : (
                    t("reset_password.button")
                  )}
                </Button>
              </Form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
      <Dialog
        //infoMessage
        open={infoMessage}
        onClose={() => setInfoMessage(false)}
        sx={{
          height: "100vh",
          overflowY: "auto",
          ".MuiDialog-container": {
            alignItems: isMobile ? "flex-start" : "center",
          },
        }}
        PaperProps={{
          sx: {
            margin: isMobile ? "106px 14px 0px 14px" : "0px 14px 0px 14px",
            width: "100%",
            maxWidth: "400px",
            height: "auto",
            maxHeight: "100%",
            borderRadius: "var(--primary-border-radius)",
            overflowY: "unset",
          },
        }}
      >
        <DialogTitle
          align="center"
          sx={{
            borderRadius:
              "var(--primary-border-radius) var(--primary-border-radius) 0 0",
            backgroundColor: "var(--secondary-background-color)",
            fontSize: "12px",
            lineHeight: "12px",
            textTransform: "uppercase",
            padding: "21px 0",
            position: "relative",
          }}
        >
          {t("reset_password.confirmation.title")}
          <IconButton
            aria-label="close"
            onClick={() => setInfoMessage(false)}
            sx={{
              position: "absolute",
              right: "14px",
              top: "50%",
              width: "20px",
              height: "20px",
              transform: "translate(0, -50%)",
              backgroundColor: "var(--primary-background-color)",
              padding: "0",
              borderRadius: "4px !important",
            }}
          >
            <CloseIcon sx={{ fontSize: "16px" }} />
          </IconButton>
        </DialogTitle>
        <DialogContent className="reset_password_dialog-content">
          <DialogContentText
            style={{
              fontSize: "12px",
              padding: "12px 0",
            }}
            className="primary-text-color"
            align="center"
          >
            {t("reset_password.confirmation.text")}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
});

export default ResetPassword;
